import React from "react"
import Hero from "./Hero"
import JobInfo from "./JobInfo"
import Team from "./Team"
import PreviousExperiences from "./PreviousExperiences"
import WorkAtSaits from "components/WorkAtSaits"
import AvailablePositions from "components/AvailablePositions"
import Footer from "components/Footer"
import { Helmet } from "react-helmet"

class JobDescription extends React.Component {
  render() {
    const { heroDescription, previousExperiences, ...rest } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {`Jobba som ${this.props.position.toLowerCase()} i ${
              this.props.location
            }`}
          </title>
          <meta name="description" content={heroDescription} />
        </Helmet>
        <Hero heroDescription={heroDescription} />
        <JobInfo {...rest} />
        <Team />
        <PreviousExperiences previousExperiences={previousExperiences} />
        <WorkAtSaits />
        <AvailablePositions variant="light" />
        <Footer />
      </React.Fragment>
    )
  }
}

export default JobDescription



// WEBPACK FOOTER //
// ./src/components/JobDescription/index.jsx